import hsBgAlert from '../../assets/images/hs_bg_alert.png';
import bannerBg1 from '../../assets/images/banner_bg_orange4.png';

export const useStyles = () => ({
	textGreen: {
		fontSize: 36,
		lineHeight: '48px',
		color: '#28d799',
	},
	saleTimerBanner: {
		backgroundSize: 'cover',
		backgroundPosition: 'center center',
		backgroundRepeat: 'no-repeat', 
		background: `#181E22 url(${hsBgAlert})`,
		position: 'relative',
		cursor: 'pointer',
	},
	bannerBg1: {
		backgroundSize: 'cover',
		backgroundPosition: 'center center',
		backgroundRepeat: 'no-repeat', 
		background: `#181E22 url(${bannerBg1})`,
	},
	saleTimerBannerContainer: {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'nowrap',
		justifyContent: 'space-between',
		maxWidth: 990,
		padding: '10px 10px 0 10px',
		position: 'relative',
		zIndex: 10,
	},
	saleTimerBannerPhones: {
		width: 140,
	},
	saleTimerBannerText: {
		fontSize: 24,
		fontWeight: '700',
		lineHeight: '36px',
		color: '#ffffff',
		maxWidth: 460,
	},
	saleTimerBannerClock: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		background: '#101416',
		borderRadius: 12,
		border: '1px solid #525B60',
		margin: '0px 30px 10px',
		padding: '10px',
		color: '#ffffff',
	},
	saleTimerBannerClockItem: {
		minWidth: 70,
		minHeight: 60,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		padding: '4px 15px 2px',
		fontSize: 40,
		lineHeight: '45px',
		fontWeight: 700,
	},
	saleTimerBannerClockItemText: {
		fontSize: 12,
		fontWeight: 600,
		lineHeight: '16px',
		color: '#93999C',
		textTransform: 'lowercase',
	},
	saleTimerBannerClockItemSeparator: {
		fontSize: 20,
		fontWeight: 700,
		marginTop: '-25px',
	},
	saleTimerBannerCTA: {
		position: 'relative',
		marginBottom: 10,
		fontSize: 15,
		fontWeight: '700',
		lineHeight: '17px',
		color: '#ffffff',
		background: 'linear-gradient(90deg, #FF8F00 0%, #F86605 100%)',
		borderRadius: 12,
		padding: '15px 30px 15px 30px',
		minWidth: 150,
		textAlign: 'center',
		overflow: 'hidden',
		'&::before': {
			content: '""',
			display: 'block',
			position: 'absolute',
			inset: 0,
			background: 'linear-gradient(90deg, #CC7200 0%, #C65204 100%)',
			opacity: 0,
			transition: 'opacity 0.3s ease',
			zIndex: 0,
		},
		'&:hover::before': {
			opacity: 1,
		},
		'span, &>*': {
			position: 'relative',
			zIndex: 1,
		}
	},
	'@media (max-width: 991px)': {
		saleTimerBannerContainer: {
			justifyContent: 'center'
		},
		saleTimerBannerText: {
			fontSize: 20,
		},
		textGreen: {
			fontSize: 32,
		},
		saleTimerBannerClockItem: {
			fontSize: 36,
		},
	},
	'@media (max-width: 800px)': {
		saleTimerBannerContainer: {
			flexDirection: 'column',
			paddingBottom:	'12px',
		},
	}
});